var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurBlueBusBuilder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0069b1",
    d: "m13.091 14.535 5.7 5.7 2.005-2.052-5.7-5.7-2.005 2.052m3.534-4.94c-.37 0-.77-.048-1.083-.18L4.722 20.188l-2.005-2.005 7.04-7.03-1.682-1.691-.684.665-1.378-1.34v2.717l-.665.665-3.344-3.382.665-.665h2.67l-1.33-1.339 3.382-3.382a2.827 2.827 0 0 1 4.009 0L9.395 5.453l1.34 1.33-.675.674 1.701 1.692 1.729-1.786c-.133-.314-.19-.713-.19-1.065a3.315 3.315 0 0 1 3.325-3.344c.56 0 1.054.133 1.501.4L15.589 5.89l1.425 1.425 2.537-2.537c.266.447.399.922.399 1.52a3.298 3.298 0 0 1-3.325 3.297Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurBlueBusBuilder);
export default __webpack_public_path__ + "static/media/OurBlueBusBuilder.75eba2dd0b57340e6365d526e2cc6c8c.svg";
export { ForwardRef as ReactComponent };